export class waypoint {
    location?: geolocation;
    stopover?: boolean;
}

export class geolocation {
    lat?: number;
    lng?: number;
}